import FeatureAccess from './FeatureAccess';

export default FeatureAccess;
